import React from 'react'
import { hydrate, render } from 'react-dom'
import App from './App'
import { Provider } from 'react-redux'
import { createBrowserHistory } from 'history'
import configureStore from 'store'
import * as serviceWorker from './serviceWorker'
import 'url-search-params-polyfill'
// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyAqoEvc9IUnkL36rW-q5ZjbJbT1X0f3bd4',
  authDomain: 'personal-7fab5.firebaseapp.com',
  databaseURL: 'https://personal-7fab5.firebaseio.com',
  projectId: 'personal-7fab5',
  storageBucket: 'personal-7fab5.appspot.com',
  messagingSenderId: '629966435278',
  appId: '1:629966435278:web:aed12c367c00b8b534719f',
  measurementId: 'G-4K7S6CEZK2'
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
getAnalytics(app)

const history = createBrowserHistory()
const store = configureStore({}, history)
const rootElement = document.getElementById('root')
const Component = (
  <Provider store={store}>
    <App history={history} />
  </Provider>
)

window.snapSaveState = () => {
  document.getElementById('root').innerHTML = ''
  document.querySelectorAll('link[rel="preload"]').forEach(link => {
    const scriptTag = document.createElement('script')
    scriptTag.src = link.getAttribute('href')
    if (!/\/static\/js\/main.\w{8}.chunk.js/.test(scriptTag.src)) {
      document.body.appendChild(scriptTag)
    }
    link.parentElement.removeChild(link)
  })
}

if (rootElement.hasChildNodes()) {
  hydrate(Component, rootElement)
} else {
  render(Component, rootElement)
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
